// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---src-pages-giftlist-js": () => import("./../../../src/pages/giftlist.js" /* webpackChunkName: "component---src-pages-giftlist-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-labo-js": () => import("./../../../src/pages/labo.js" /* webpackChunkName: "component---src-pages-labo-js" */)
}

